import { Message, MetaConversation } from 'lib-shared-legacy-types';

import { isReviewChannel } from '../reviewChannel';

/**
 * On review channels the agent's reply is an outbound message, while the review
 * itself (and any subsequent review edits) arrive as inbound messages. Returns
 * the last outbound message, or null if the agent has not replied yet.
 *
 * A just-submitted reply exists as an optimistic conversation:add_message entry
 * until the server event merges into it in place, so both types count —
 * otherwise the reply-sent state would only show after a refresh.
 *
 * @param metaConversation
 * @returns {Message | null} - Last reply if it exists
 */
export const getLastReviewReply = ({
  conversation,
  messages,
}: MetaConversation): Message | null => {
  if (!isReviewChannel(conversation.initial_channel)) {
    return null;
  }

  const replies = messages.filter(
    ({ type, direction }) =>
      ['conversation:message_added', 'conversation:add_message'].includes(
        type,
      ) && direction === 'outbound',
  );

  return replies.at(-1) ?? null;
};
